const mapEls = document.querySelectorAll('.map');

if (mapEls.length > 0) {
    let isDesktop = window.matchMedia('(min-width: 768px)').matches;
    let isLarge = window.matchMedia('(min-width: 1200px)').matches;

    window.addEventListener('resize', () => {
        isDesktop = window.matchMedia('(min-width: 768px)').matches;
        isLarge = window.matchMedia('(min-width: 1200px)').matches;
    });

    mapEls.forEach((mapEl) => {
        const mapContentEls = mapEl.querySelectorAll('.map__content');
        const mapMarkerEls = mapEl.querySelectorAll('.map__map-marker');
        const mapHeadlineEl = mapEl.querySelector('.map__headline');
        const mapMapEl = mapEl.querySelector('.map__map');
        const mapInfoEl = mapEl.querySelector('.map__info');
        const mapImageEl = mapEl.querySelector('.map__map-image');
        const mapImageElHeight = mapImageEl.scrollHeight;
        const mapImageElWidth = mapImageEl.scrollWidth;

        mapContentEls.forEach((mapContentEl) => {
            const id = mapContentEl.dataset.id;
            const mapMarkerEl = mapEl.querySelector(`.map__map-marker[data-id="${id}"]`);
            const mapContentCloseEls = mapContentEl.querySelectorAll('.map__content-close');

            const markerDistanceTop =
                mapMarkerEl.getBoundingClientRect().top - mapMapEl.getBoundingClientRect().top + 100;
            const markerDistanceLeft =
                mapMarkerEl.getBoundingClientRect().left - mapImageEl.getBoundingClientRect().left;

            positionContent(mapContentEl);
            window.addEventListener('resize', () => {
                positionContent(mapContentEl);
            });

            mapContentCloseEls.forEach((mapContentCloseEl) => {
                mapContentCloseEl.addEventListener('click', () => {
                    resetMap();
                });
            });

            mapMarkerEl.addEventListener('click', () => {
                resetMap();

                document.body.classList.add('map--open');
                mapInfoEl.classList.add('map__info--hidden');
                mapMarkerEl.classList.add('map__map-marker--active');
                mapContentEl.classList.add('map__content--active');

                if (isDesktop) {
                    window.scrollTo({ behavior: 'smooth', top: mapEl.offsetTop + mapHeadlineEl.offsetTop - 5 });
                    // needed to move header out of viewport
                    setTimeout(() => {
                        window.scrollTo({ behavior: 'smooth', top: mapEl.offsetTop + mapHeadlineEl.offsetTop });
                    }, 150);

                    const translateX = mapImageElWidth / 2 - markerDistanceLeft + (isLarge ? 0 : 100);
                    const translateY = mapImageElHeight / 2 - markerDistanceTop;
                    const translateString = `translate(${translateX}px, ${translateY}px)`;
                    mapImageEl.style.transform = translateString;

                    mapImageEl.classList.add('map__map-image--zoom');
                }

                mapContentEl.focus();
            });
        });

        function positionContent(mapContentEl) {
            if (isDesktop) {
                const contentDistanceTop =
                    mapMapEl.getBoundingClientRect().top - mapEl.getBoundingClientRect().top + 55;
                mapContentEl.style.top = `${contentDistanceTop}px`;
            } else {
                mapContentEl.style.top = '';
            }
        }

        function resetMap() {
            mapMarkerEls.forEach((mapMarkerEl) => {
                mapMarkerEl.classList.remove('map__map-marker--active');
            });

            mapContentEls.forEach((mapContentEl) => {
                mapContentEl.classList.remove('map__content--active');
                mapInfoEl.classList.remove('map__info--hidden');
            });

            document.body.classList.remove('map--open');

            mapImageEl.classList.remove('map__map-image--zoom');
            mapImageEl.style.transform = 'none';
        }
    });
}
